import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
export class FormQuestionControlService {
constructor() { }
/**
 * @param {?} questions
 * @return {?}
 */
toFormGroup(questions: any[]) {
    let /** @type {?} */ group: any = {};

    for (let /** @type {?} */ question of questions) {
      if (question.questions == null) {
        let /** @type {?} */ myValidations = null;

        if (question.required || question.validation != null) { myValidations = []; }

        if (question.required) { myValidations.push(Validators.required); }

        if (question.validation != null && question.validation !== {}) { myValidations.push(question.validation.action); }

        group[question.key] = new FormControl(question.value || '', myValidations);
      } else {
        group[question.key] = this.toFormGroup(question.questions);
      }
    }
    return new FormGroup(group);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormQuestionControlService_tsickle_Closure_declarations() {
/** @type {?} */
FormQuestionControlService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormQuestionControlService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
